module.exports = __webpack_public_path__ + "img/zhicunbao_1.a8cd7120.jpg";